.name-label {
  color: var(--blue-006FBB);
  font-weight: 500;
  text-align: left;
}

.sku-label {
  color: var(--gray-637381);
}

.flex-label {
  min-width: 90px;
  display: block;
}
